import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueLazyload from 'vue-lazyload'

// import vuex
import { mapState } from 'vuex'

// lodash
import each from 'lodash/each.js'
import uniq from 'lodash/uniq.js'
import uniqBy from 'lodash/uniqBy.js'
import map from 'lodash/map.js'
import filter from 'lodash/filter.js'
import isEmpty from 'lodash/isEmpty.js'
import chunk from 'lodash/chunk.js'
import orderBy from 'lodash/orderBy.js'
import includes from 'lodash/includes.js'
import forOwn from 'lodash/forOwn.js'
import throttle from 'lodash/throttle.js'
import size from 'lodash/size.js'

var _ = { each, uniq, uniqBy, map, filter, isEmpty, chunk, orderBy, includes, forOwn, throttle, size }

Vue.prototype._ = _

Vue.prototype.$Cag = window.Cag

Vue.config.productionTip = false

// lazy-load
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/images/site/noimage.gif',
  loading: '/images/site/loaders/loading_padded.svg',
  attempt: 1
})

// vue mixin
var carSearchGlobal = {
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['stockType']),
    niceStockType () {
      if (this.stockType === 'new') {
        return 'New'
      }
      if (this.stockType === 'used') {
        return 'Pre-Owned'
      }
      if (this.stockType === 'all') {
        return 'All'
      }
      return 'New'
    },
    notPopFields () {
      return ['sortBy', 'sortType', 'page']
    }
  },
  methods: {
    /**
     * Push path inputs to router
     */
    pushToRouter: function (name, query) {
      this.$router.push({ name: name, query: query }).catch(err => {
        // Ignore the vuex err regarding navigating to the page they are already on.
        if (err.name !== 'NavigationDuplicated') {
        // But print any other errors to the console
          console.error(err)
        }
      })
    },
    /**
     * Reset our search filters
     */
    resetSearchFilters () {
      for (const filter in this.$store.state.searchFilters) {
        if (Array.isArray(this.$store.state.searchFilters[filter])) {
          this.$store.state.searchFilters[filter] = []
        } else {
          this.$store.state.searchFilters[filter] = undefined
        }
      }

      // save our filters to state
      this.$store.dispatch('storeSearchFilters', this.$store.state.searchFilters)
    }
  }
}

new Vue({
  mixins: [carSearchGlobal],
  router,
  store,
  render: h => h(App)
}).$mount('#app')
